import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetWildberriesCategoriesRequest,
    type OpenApiGetWildberriesCategoriesResponseSuccess,
    type OpenApiImportWildberriesSetupDeleteRequest,
    type OpenApiImportWildberriesSetupDeleteResponseSuccess,
    type OpenApiImportWildberriesSetupGetRequest,
    type OpenApiImportWildberriesSetupGetResponseSuccess,
    type OpenApiImportWildberriesSetupRequest,
    type OpenApiImportWildberriesSetupResponseSuccess,
} from '#shared/api/schema';

const WildberriesSetupTag = 'WildberriesSetup';

const api = createApi({
    name: 'entities/integration/api/wildberriesApi',
    baseQuery: createBaseQuery(apiV1Request),
    tagTypes: [WildberriesSetupTag],
    endpoints: (builder) => {
        return {
            setupGet: builder.query<
                OpenApiImportWildberriesSetupGetResponseSuccess,
                OpenApiImportWildberriesSetupGetRequest
            >({
                query: () => {
                    return {
                        url: '/integrations/wildberries/setup',
                        method: 'GET',
                    };
                },
                providesTags: [WildberriesSetupTag],
            }),
            setupAdd: builder.mutation<
                OpenApiImportWildberriesSetupResponseSuccess,
                OpenApiImportWildberriesSetupRequest
            >({
                query: (payload) => {
                    return {
                        url: '/integrations/wildberries/setup',
                        method: 'POST',
                        body: payload,
                    };
                },
                invalidatesTags: (_, error) => {
                    if (error) {
                        return [];
                    }

                    return [WildberriesSetupTag];
                },
            }),
            setupDelete: builder.mutation<
                OpenApiImportWildberriesSetupDeleteResponseSuccess,
                OpenApiImportWildberriesSetupDeleteRequest
            >({
                query: () => {
                    return {
                        url: '/integrations/wildberries/setup',
                        method: 'DELETE',
                    };
                },
                invalidatesTags: (_, error) => {
                    if (error) {
                        return [];
                    }

                    return [WildberriesSetupTag];
                },
            }),
            dictionaryCategories: builder.query<
                OpenApiGetWildberriesCategoriesResponseSuccess,
                OpenApiGetWildberriesCategoriesRequest
            >({
                query: () => {
                    return {
                        url: '/integrations/wildberries/dictionaries/categories',
                        method: 'GET',
                    };
                },
            }),
        };
    },
});

export const integrationWildberriesSetupAdd = api.endpoints.setupAdd.mutate;
export const integrationWildberriesSetupDelete = api.endpoints.setupDelete.mutate;
export const useIntegrationWildberriesSetup = api.useSetupGetQuery;
export const integrationWildberriesSetupGet = api.endpoints.setupGet.query;

export const integrationWildberriesSetupInvalidateCache = () => {
    api.util.invalidateTags([WildberriesSetupTag]);
};

export const useIntegrationWildberriesDictionaryCategories = api.useDictionaryCategoriesQuery;
